export const Validators = {
    url: value => {
        try {
            new URL(value);
            return true;
        } catch (_) {
            return false;
        }
    }
};
